/* Note: This is an autogenerated file. Please DO NOT modify anything manually here. */
import * as Types from "src/generated/graph-api";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GQLUpdateUserAvatarMutationVariables = Types.Exact<{
	identityUserId: Types.Scalars["ID"]["input"];
	input: Types.GQLUpdateIdentityUserAvatarInput;
}>;

export type GQLUpdateUserAvatarMutation = {
	__typename: "Mutation";
	identityUser: {
		__typename: "IdentityUserMutations";
		avatar: { __typename: "IdentityUser"; id: string; photoUrl: string | null };
	};
};

export const UpdateUserAvatarDocument = gql`
    mutation UpdateUserAvatar($identityUserId: ID!, $input: UpdateIdentityUserAvatarInput!) {
  identityUser(id: $identityUserId) {
    avatar(input: $input) {
      id
      photoUrl
    }
  }
}
    `;
export type GQLUpdateUserAvatarMutationFn = Apollo.MutationFunction<
	GQLUpdateUserAvatarMutation,
	GQLUpdateUserAvatarMutationVariables
>;

/**
 * __useUpdateUserAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAvatarMutation, { data, loading, error }] = useUpdateUserAvatarMutation({
 *   variables: {
 *      identityUserId: // value for 'identityUserId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAvatarMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GQLUpdateUserAvatarMutation,
		GQLUpdateUserAvatarMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GQLUpdateUserAvatarMutation,
		GQLUpdateUserAvatarMutationVariables
	>(UpdateUserAvatarDocument, options);
}
export type UpdateUserAvatarMutationHookResult = ReturnType<
	typeof useUpdateUserAvatarMutation
>;
export type UpdateUserAvatarMutationResult =
	Apollo.MutationResult<GQLUpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationOptions = Apollo.BaseMutationOptions<
	GQLUpdateUserAvatarMutation,
	GQLUpdateUserAvatarMutationVariables
>;
